import type { AgentData } from "@/services/agent-list";

/**
 * 用户视角下智能体是否可用：
 * 智能体（status）开启 &&（用户订阅（enableStatus）开启 || 用户权限（manageStatus）开启）
 */
export function isAgentAvailableForUser(agent: AgentData | null | undefined): boolean {
  if (!agent) return false;
  return agent.status === 1 && (agent.enableStatus === 1 || agent.manageStatus === 1);
}
